// File: frontend/src/services/AnalyticsService.js

/**
 * Service for collecting minimal analytics data for security and fraud prevention
 * after GDPR consent is granted.
 */
class AnalyticsService {
  constructor() {
    this.isInitialized = false;
    this.sessionStartTime = null;
  }

  /**
   * Initialize the analytics service once consent is granted
   */
  initialize() {
    if (this.isInitialized) return;
    
    this.sessionStartTime = new Date();
    this.setupBasicTracking();
    this.isInitialized = true;
    
    // Start session tracking
    this.trackPageView(window.location.pathname);
  }

  /**
   * Set up basic tracking for security purposes
   */
  setupBasicTracking() {
    // Track page navigation
    window.addEventListener('popstate', () => {
      this.trackPageView(window.location.pathname);
    });
  }

  /**
   * Track page views
   */
  trackPageView(path) {
    const data = {
      path: path || window.location.pathname,
      referrer: document.referrer,
      timestamp: new Date().toISOString()
    };
    
    this.sendAnalyticsData('page_view', data);
  }

  /**
   * Track specific events
   */
  trackEvent(eventName, eventData = {}) {
    if (!this.isInitialized) return;
    
    const data = {
      ...eventData,
      timestamp: new Date().toISOString()
    };
    
    this.sendAnalyticsData(eventName, data);
  }

  /**
   * Send analytics data to backend
   */
  sendAnalyticsData(eventType, data) {
    // In production, this would send data to your backend API
    console.log(`[Analytics] ${eventType}:`, data);
    
    // Actual implementation would use fetch
    /*
    fetch('/api/analytics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        eventType,
        data,
        sessionId: this.getSessionId(),
        timestamp: new Date().toISOString()
      }),
    }).catch(error => {
      console.error('Error sending analytics data:', error);
    });
    */
  }

  /**
   * Get or create a unique session ID
   */
  getSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    
    if (!sessionId) {
      sessionId = this.generateUUID();
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    
    return sessionId;
  }

  /**
   * Generate a UUID for session tracking
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default new AnalyticsService();